import validateResponse from '../../common/Util'

export function GetUserNetPromoterScore(userID) {
    console.log('in getUserNetPromoterScore' + userID);
    return fetch(process.env.REACT_APP_HOST_API_URL + '/developer/mvc/api/' + userID + '/netpromoterscore', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            method: 'GET'
    })
    .then(results=> {
        validateResponse(results);
        return results.json();
    })
    .catch(error => {
        console.log("Error getting getUserNetPromoterScore data from server: " + error.message);
        window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/errorRedirect.jsp?errorKey=request.processing.error";
        return Promise.reject();
    });
}



// WEBPACK FOOTER //
// ./src/api/get/GetUserNetPromoterScore.js